import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useMediaQuery, BREAKPOINTS } from '../../../hooks/useMediaQuery';
const ReviewCard = ({ name, content }) => {
  return (
    <div className="w-full p-[24px] bg-primary-background rounded-2xl">
      <div className="w-full flex flex-col gap-2">
        <div className="text-primary text-xl font-semibold font-inter">{name}</div>
        <div className="w-full text-secondary-text text-body-medium font-inter whitespace-normal break-keep">
          {content}
        </div>
      </div>
    </div>
  );
};

const TabletAndMobileReviewCard = ({ name, content }) => {
  return (
    <div className="w-full p-6 bg-primary-background rounded-2xl">
      <div className="w-full flex flex-col gap-2">
        <div className="text-primary text-xl font-semibold font-inter">{name}</div>
        <div className="w-full text-secondary-text text-body-medium font-inter whitespace-normal break-keep">
          {content}
        </div>
      </div>
    </div>
  );
};

export default function ReviewSection() {
  const { ref: sectionRef, inView } = useInView({
    threshold: 0.5,
    triggerOnce: false,
  });
  const leftColumnReviews = [
    {
      name: 'Smsh80',
      content: '아이가 영어에 흥미를 가졌어요. 자신감 Up! 아이에 맞는 수업을 잘 진행해주셔서 아이 실력이 엄청 늘었어요. 귀가 트이고 말문이 터지는 영어수업입니다!'
    },
    {
      name: 'nlnl',
      content: '유치부때부터 다녔어요. 중간에 힘들어하는 시기도 있었지만 잘 지나고 나니, 지금은 너무 재밌게 다녀요. 영어도서관도 즐겁게 다니고 있어요.'
    },
    {
      name: 'Eka',
      content: '저희 아이가 2년째 잘 다니고 있는 아나톨레! 아나톨레의 큰 장점은 학생들 관리가 잘된다는 거예요~ 꼼꼼하게 피드백을 해주십니다. 실력이 일취월장 하고 있습니다 ^^'
    },
    {
      name: 'Niariad',
      content: '원어민 선생님께서 유쾌하고 학생들과 소통을 잘하셔서 아이가 즐거워하네요. 숙제관리도 꼼꼼하고 체계적입니다. 영어도서관도 이용할 수 있는 것은 큰 장점이구요~^^'
    },
    {
      name: 'Eun3677',
      content: '녹음해서 올리고, 피드백받고 시험본거 같이 공유하고, 숙제도 적당히 많아서 아이 영어 실력이 느는게 보여요! 아주 만족스러워요 ^^ 아이도 영어학원 너무 재밌데요!'
    },
    {
      name: 'Nuri',
      content: '3년째 다니고 있어요~ ^^ 수업 모두 만족스럽고, 재원생들에게 혜택이 많이 주어져서 부담스럽지 않은 영어도서관! 친절한 소통까지~ 아주 만족합니다.'
    },
    {
      name: 'REINA2012',
      content: '아이가 즐겁게 영어배우고 있어요. 리딩 리스닝 문법 라이팅 모두 지도 잘 해주시고, 아이들 관리가 잘됩니다. 원어민 선생님 수업도 정말 재미있데요.'
    },
    {
      name: 'Fani',
      content: '선생님들의 세심한 피드백 덕분에 약점이 보완되고, 영어에 대한 자신감이 확실히 많이 늘었어요!'
    }
  ];

  const rightColumnReviews = [
    {
      name: 'Smsh80',
      content: '아이가 영어에 흥미를 가졌어요. 자신감 Up! 아이에 맞는 수업을 잘 진행해주셔서 아이 실력이 엄청 늘었어요. 귀가 트이고 말문이 터지는 영어수업입니다!'
    },
    {
      name: 'nlnl',
      content: '유치부때부터 다녔어요. 중간에 힘들어하는 시기도 있었지만 잘 지나고 나니, 지금은 너무 재밌게 다녀요. 영어도서관도 즐겁게 다니고 있어요.'
    },
    {
      name: 'Eka',
      content: '저희 아이가 2년째 잘 다니고 있는 아나톨레! 아나톨레의 큰 장점은 학생들 관리가 잘된다는 거예요~ 꼼꼼하게 피드백을 해주십니다. 실력이 일취월장 하고 있습니다 ^^'
    },
    {
      name: 'Niariad',
      content: '원어민 선생님께서 유쾌하고 학생들과 소통을 잘하셔서 아이가 즐거워하네요. 숙제관리도 꼼꼼하고 체계적입니다. 영어도서관도 이용할 수 있는 것은 큰 장점이구요~^^'
    },
    {
      name: 'Eun3677',
      content: '녹음해서 올리고, 피드백받고 시험본거 같이 공유하고, 숙제도 적당히 많아서 아이 영어 실력이 느는게 보여요! 아주 만족스러워요 ^^ 아이도 영어학원 너무 재밌데요!'
    },
    {
      name: 'Nuri',
      content: '3년째 다니고 있어요~ ^^ 수업 모두 만족스럽고, 재원생들에게 혜택이 많이 주어져서 부담스럽지 않은 영어도서관! 친절한 소통까지~ 아주 만족합니다.'
    },
    {
      name: 'REINA2012',
      content: '아이가 즐겁게 영어배우고 있어요. 리딩 리스닝 문법 라이팅 모두 지도 잘 해주시고, 아이들 관리가 잘됩니다. 원어민 선생님 수업도 정말 재미있데요.'
    },
    {
      name: 'Fani',
      content: '선생님들의 세심한 피드백 덕분에 약점이 보완되고, 영어에 대한 자신감이 확실히 많이 늘었어요!'
    }
  ];

  // 리뷰 리스트를 두 번 렌더링하여 애니메이션의 반복이 자연스럽게 연결되도록 함.
  const duplicatedLeftReviews = [...leftColumnReviews, ...leftColumnReviews];
  const duplicatedRightReviews = [...rightColumnReviews, ...rightColumnReviews];


  const DesktopContents = ({ inView }) => {
    return (
      <div className="max-w-[1480px] mx-auto px-4 py-[5px] flex flex-col md:flex-row items-center gap-10">
        <div className="flex-1">
          <div className="flex flex-col gap-10 my-[100px]">
            <div className="flex flex-col gap-6">
              <h2 className={`w-[373px] text-white text-display-large font-semibold font-inter leading-[80px] ${inView ? 'animate-fadeSlideUp' : ''}`}>
                What do they say about{' '}
                <span className="text-tertiary">Anatole Academy?</span>
              </h2>
              <p className={`text-white text-headline-small font-semibold font-inter ${inView ? 'animate-fadeSlideUp delay-[1000ms]' : ''}`}>
                학생과 학부모님의 생생한 후기!
                <br />
                색다른 영어 학습을 경험해보세요!
              </p>
            </div>
            <button className="py-[15px] bg-primary-background rounded-lg backdrop-blur-[6px] w-[154px] animate-heartBeat">
              <div className="text-primary text-headline-small font-semibold font-inter">
                입학 문의
              </div>
            </button>
          </div>
        </div>

        <div className="flex-1">
          <div className="h-[800px] overflow-hidden">
            <div className="flex flex-col gap-10 items-end animate-scrollDown">
              {duplicatedLeftReviews.map((review, index) => (
                <ReviewCard key={index} {...review} />
              ))}
            </div>
          </div>
        </div>

        <div className="flex-1">
          <div className="h-[800px] overflow-hidden">
            <div className="flex flex-col gap-10 items-start animate-scrollUp">
              {duplicatedRightReviews.map((review, index) => (
                <ReviewCard key={index} {...review} />
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const TabletAndMobileContents = ({ inView }) => {
    return (
      <div className="max-w-[1480px] mx-auto flex flex-col desktop:flex-row items-start gap-10 px-[20px] tablet:px-[35px] py-[50px] desktop:py-[60px]">
        <div className="flex flex-col ">
          <div className="flex flex-col gap-10">
            <div className="flex flex-col gap-6">
              <h2 className={`text-white text-headline-large font-semibold font-inter desktop:leading-[60px] leading-[40px] ${inView ? 'animate-fadeSlideUp' : ''}`}>
                What do they say about{' '}
                <span className="text-tertiary">Anatole Academy?</span>
              </h2>
              <p className={`text-white text-title-medium font-semibold font-inter ${inView ? 'animate-fadeSlideUp delay-[1000ms]' : ''}`}>
                학생과 학부모님의 생생한 후기!<br />
                색다른 영어 학습을 경험해보세요!
              </p>
            </div>

          </div>
        </div>

        <div className="grid tablet:grid-cols-2 grid-cols-1 gap-[40px] mt-[-10px]">
          {leftColumnReviews.slice(0, 8).map((review, index) => (
            <TabletAndMobileReviewCard key={index} {...review} />
          ))}
        </div>
        <button className="py-[15px] bg-primary-background rounded-lg backdrop-blur-[6px] w-[150px] animate-heartBeat self-end">
          <div className="text-primary text-title-medium font-semibold font-inter">
            입학 문의
          </div>
        </button>
      </div>
    )
  }
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE);
  const isTablet = useMediaQuery(BREAKPOINTS.TABLET);
  return (
    <section ref={sectionRef} className="bg-primary">
      {(isTablet || isMobile) ? <TabletAndMobileContents inView={inView} /> : <DesktopContents inView={inView} />}
    </section>
  );
}